import React, {useState} from 'react'
import MaterialTable from '@material-table/core';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import {EmptyList} from "../../../../components/EmptyList";
import {useDispatch, useSelector} from "react-redux";
import ESignUpload_XXXX from "./components/ESignUpload";
import FilterListIcon from "@mui/icons-material/FilterList";
import {SearchPanel} from "../../../Document/components";
import {NameBasedMenuItemWithIdReturn} from "../../../Document/components/panelSegments/components/NameBasedMenuItem";
import {GuidBasedMenuItem} from "../../../Document/components/panelSegments/components";
import ESignUpload from "./components/ESignUpload/ESignUpload";
import DocumentAttributes from "../../../Document/ListDocument/components/DocumentAttributes";
import {eSignActions} from "../../../../store/actions";

const ESignDocumentDetails = props => {
  const {
    classes,
    role,
    company,
    status,
    initialSections,
    initialCompanies,
    initialCategories,
    initialClassifications,
    initialDocuments,
    onView,
    viewer
  } = props

  const dispatch = useDispatch();
  const {id} = useSelector(state => state.authentication.user);
  const [showUpload, setShowUpload] = useState(false);
  const [documentData, setDocumentData] = useState(null);
  const [selectedRows, setSelectedRows] = useState([]);
  const [companySelect, setCompanySelect] = useState(company);
  const [sectionSelect, setSectionSelect] = useState("Company");
  const [categorySelect, setCategorySelect] = useState("Uncategorized");
  const [classificationSelect, setClassificationSelect] = useState("Uncategorized");

  let columns = [
    {
      title: 'File Name',
      field: 'original_filename',
      cellStyle: {
        width: '30%',
        maxWidth: '30%'
      }
    },
    {
      title: 'Page Count',
      field: 'page_count'
    }
  ];

  let options= {
    showSelectAllCheckbox: false,
    selection: true,
    selectionProps: rowData => ({
      disabled: rowData.uploaded,
      color: 'primary'
    }),
    emptyRowsWhenPaging: false,
    pageSize: initialDocuments.length > 10 ? 20 : (initialDocuments.length > 5 ? 10 : 5),
    search: true,
    searchFieldAlignment: "left",
    actionsColumnIndex: -1,
    rowStyle: {
      height: '3px'
    }
  }

  let actions= [
    (rowData) => {
      let iconColor = '#000000';
      return (
        {
          icon: () => <FileUploadIcon/>,
          tooltip: 'Upload File',
          isFreeAction: true,
          onClick: fileUploadClick
        })
    }
  ];

  if (status.toLowerCase() === 'signed'){
    options["selection"] = true;
  } else {
    options["selection"] = false;
  }

  const handleCategorySelect = event => {
    setCategorySelect(event.target.value);
  };

  const handleClassificationSelect = event => {
    setClassificationSelect(event.target.value);
  };

  const handleCompanySelect = event => {
    setCompanySelect(event.target.value);
  };

  const handleSectionSelect = event => {
    setSectionSelect(event.target.value);
  };


  const onShowUpload = () => {
    setShowUpload(true);
  };

  const onHandleCloseShowUpload = () => {
    setShowUpload(false);
  };


  function rowClick(event, rowData) {
    event.preventDefault();
    onView(rowData);
  }


  function fileUploadClick(event, rowData) {
    event.preventDefault();
    setDocumentData(rowData);
    setShowUpload(true);
  }

  const onUploadFiles = () => {
    selectedRows.forEach(function (r) {
    });

    // await Promise.all(filePromises).then(() => {/*Nothing*/});

    let eSignData = {
      company: companySelect,
      user: id,
      section: sectionSelect,
      category: categorySelect,
      classification: classificationSelect,
      fileESignLinks: selectedRows
    }
    setShowUpload(false);

    if (selectedRows.length > 0 )
      dispatch(eSignActions.uploadESignDocuments(eSignData));
  }

  return(
    <div style={{width: "100%", height: "100%", padding: 0}}>
      {(status.toLowerCase() === 'signed') ? (
        <MaterialTable
          localization={{
            body: {
              emptyDataSourceMessage: (
                <EmptyList
                  label="No eSign Documents to Display!"
                />
              ),
            },
          }}
          title=""
          options={options}
          exportbutton={true}
          columns={columns}
          data={initialDocuments}
          onRowClick={rowClick}
          onSelectionChange={(rows) => {
            setSelectedRows(rows);
          }}
          actions={actions}
        />
      ) : (
        <MaterialTable
          localization={{
            body: {
              emptyDataSourceMessage: (
                <EmptyList
                  label="No eSign Documents to Display!"
                />
              ),
            },
          }}
          title=""
          options={options}
          exportbutton={true}
          columns={columns}
          data={initialDocuments}
          onRowClick={rowClick}
          onSelectionChange={(rows) => {
            setSelectedRows(rows);
          }}
        />
      )}
      {showUpload &&
        <ESignUpload
          style={{
            position: 'absolute',
            border: '2px solid #000',
            backgroundColor: 'white',
            boxShadow: '2px solid black',
            height: 80,
            width: 200
          }}
          classes={classes}
          showModal={showUpload}
          setShowModal={setShowUpload}

          initialSections={initialSections}
          initialCompanies={initialCompanies}
          initialCategories={initialCategories}
          initialClassifications={initialClassifications}

          statusSelect={status}
          sectionSelect={sectionSelect}
          companySelect={companySelect}
          categorySelect={categorySelect}
          classificationSelect={classificationSelect}

          onHandleSectionSelect={handleSectionSelect}
          onHandleCompanySelect={handleCompanySelect}
          onHandleCategorySelect={handleCategorySelect}
          onHandleClassificationSelect={handleClassificationSelect}

          searchSectionsByMethod={NameBasedMenuItemWithIdReturn}
          searchClassificationsByMethod={NameBasedMenuItemWithIdReturn}
          searchCategoriesByMethod={NameBasedMenuItemWithIdReturn}
          searchCompaniesByMethod={GuidBasedMenuItem}

          handleCloseModal={onHandleCloseShowUpload}
          onUploadFiles={onUploadFiles}
          pageTitle={'ESign Upload Details - ' + status.toUpperCase() +  ' Documents'}

          selectedDocuments={documentData}
          renderButton={true}
          buttonText="Upload"
          buttonIcon={FileUploadIcon}
          onButtonClick={onUploadFiles}
        />
      }
    </div>
  )
}

export default ESignDocumentDetails;
